export default function formatPercent(value: number) {
  try {
    if (!value) return '0%';

    const roundedValue = Math.round(Number(value) * 100 * 100) / 100;
    return `${roundedValue}%`;
  } catch (error) {
    return '0%';
  }
}
